import {Pipe, PipeTransform} from '@angular/core';

@Pipe({standalone: true, name: 'databasePipe'})
export class DatabasePipe implements PipeTransform
{

  transform(database: string, isAdmin: boolean): string
  {
    if (!database)
    {
      return '';
    }
    // public enum DATABASE { NONE,  NWDV, DDV, SW, OSDT, TEST_DDV, TEST_TURNIER };

    const db = database.toLowerCase();
    if (db === 'turnier' || db === 'prod_1')
    {
      if (isAdmin)
        return 'Prod 1';
      else return '2K-1';
    }
    else if (db === 'prod_2')
    {
      if (isAdmin)
        return 'Prod 2';
      else return '2K-2';
    }
    else if (db === 'prod_3')
    {
      if (isAdmin)
        return 'Prod 3';
      else return '2K-3';
    }
    else if (db === 'prod_4')
    {
      if (isAdmin)
        return 'Prod 4';
      else return '2K-4';
    }
    else if (db === 'prod_5')
    {
      if (isAdmin)
        return 'Prod 5';
      else return '2K-5';
    }
    else if (db === 'prod_6')
    {
      if (isAdmin)
        return 'Prod 6';
      else return '2K-6';
    }
    else if (db === 'prod_7')
    {
      if (isAdmin)
        return 'Prod 7';
      else return '2K-7';
    }
    else if (db === 'prod_8')
    {
      if (isAdmin)
        return 'Prod 8';
      else return '2K-8';
    }
    else if (db === 'prod_9')
    {
      if (isAdmin)
        return 'Prod 9';
      else return '2K-9';
    }
    else if (db === 'prod_10')
    {
      if (isAdmin)
        return 'Prod 10';
      else return '2K-10';
    }
    else if (db === 'prod_11')
    {
      if (isAdmin)
        return 'Prod 11';
      else return '2K-11';
    }
    else if (db === 'prod_12')
    {
      if (isAdmin)
        return 'Prod 12';
      else return '2K-12';
    }
    else if (db === 'prod_13')
    {
      if (isAdmin)
        return 'Prod 13';
      else return '2K-13';
    }
    else if (db === 'prod_14')
    {
      if (isAdmin)
        return 'Prod 14';
      else return '2K-14';
    }
    else if (db === 'dartcup23' || db === 'dartcup')
      return 'Dartcup';
    else if (db === 'verband')
      return 'Verband';
    else if (db === 'nwdv')
      return 'NWDV';
    else if (db === 'ddv')
      return 'DDV';
    else if (db === 'sw')
      return 'Soccerworld';
    else if (db === 'osdt')
      return 'OSDT';
    else if (db === 'test_ddv')
      return 'Test-DDV';
    else if (db === 'test_turnier')
      return 'Test 1';
    else if (db === 'local')
      return 'Lokal';

    return database;
  }
}
